import { HttpModel } from '@/Shared/domain'
import type {
  DeleteAccountDataForm,
  EmailChangeDataForm,
  MultiWebClientMerchantModel,
  PasswordChangeDataForm,
  UserModel,
  UserRepository,
} from '@/User/domain'
import {
  CreateProfileFormValues,
  UpdateProfileData,
} from '@/partnersGroups/domain/ProfileTypes'

interface IUserContract {
  getUserData: () => Promise<HttpModel<UserModel>>
  changePassword: (data: PasswordChangeDataForm) => Promise<HttpModel<boolean>>
  changeEmail: (data: EmailChangeDataForm) => Promise<HttpModel<boolean>>
  deleteAccount: (account: DeleteAccountDataForm) => Promise<HttpModel<boolean>>
  getMultiWebClientMerchants: () => Promise<HttpModel<MultiWebClientMerchantModel[]>>
  setActiveMultiWeb: (activeMerchantId: number) => Promise<HttpModel<boolean>>
  createProfile: (data: CreateProfileFormValues) => Promise<HttpModel<boolean>>
  updateProfile: (data: UpdateProfileData) => Promise<HttpModel<boolean>>
  deleteProfile: (userNameToDelete: string) => Promise<HttpModel<boolean>>
  resendWelcomeEmail: (userNameToResend: string) => Promise<HttpModel<boolean>>
  getPermissions: () => Promise<HttpModel<string[]>>
}

export const UserContract = (userRepository: UserRepository): IUserContract => ({
  getUserData: async (): Promise<HttpModel<UserModel>> =>
    await userRepository.GetUserData(),
  changePassword: async (data: PasswordChangeDataForm): Promise<HttpModel<boolean>> =>
    await userRepository.ChangePassword(data),
  changeEmail: async (data: EmailChangeDataForm): Promise<HttpModel<boolean>> =>
    await userRepository.ChangeEmail(data),
  deleteAccount: async (account: DeleteAccountDataForm): Promise<HttpModel<boolean>> =>
    await userRepository.DeleteAccount(account),
  getMultiWebClientMerchants: async (): Promise<
    HttpModel<MultiWebClientMerchantModel[]>
  > => await userRepository.GetMultiWebClientMerchants(),
  setActiveMultiWeb: async (activeMerchantId: number): Promise<HttpModel<boolean>> =>
    await userRepository.SetActiveMultiWeb(activeMerchantId),
  createProfile: async (data: CreateProfileFormValues): Promise<HttpModel<boolean>> =>
    await userRepository.CreateProfile(data),
  updateProfile: async (data: UpdateProfileData): Promise<HttpModel<boolean>> =>
    await userRepository.UpdateProfile(data),
  deleteProfile: async (userNameToDelete: string): Promise<HttpModel<boolean>> =>
    await userRepository.DeleteProfile(userNameToDelete),
  resendWelcomeEmail: async (userNameToResend: string): Promise<HttpModel<boolean>> =>
    await userRepository.ResendWelcomeEmail(userNameToResend),
  getPermissions: async (): Promise<HttpModel<string[]>> =>
    await userRepository.GetPermissions(),
})
